import Spacer from "components/Spacer";
import type { SpacerProps } from "components/Spacer";
import type { ReactStoryblokComponent } from "types/storyblok";

const SpacerAdapter = ({ blok: { hDesktop, hMobile, hTablet }, sbEditable }: ReactStoryblokComponent<SpacerProps>) => (
  <Spacer hDesktop={hDesktop} hMobile={hMobile} hTablet={hTablet} sbEditable={sbEditable} />
);

export default SpacerAdapter;
